import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(public _loginService: LoginService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(request.url != environment.tokenURL && request.url != "https://api.ipify.org/?format=json"){
            request = request.clone({
                url: environment.webApiURL + request.url,
                setHeaders: {
                    Authorization: `Bearer ${this._loginService.getToken()}`
                }
            });
    }
        return next.handle(request);
    }
}
